<template>
    <div class="plant">
		<mapPolygon></mapPolygon>
	</div>
</template>
<script>
import { reactive, ref, getCurrentInstance, toRefs } from "vue";
import mapPolygon from '../../components/map/mapPolygons.vue'
export default {
	components: {mapPolygon },
	setup() {
		const { proxy } = getCurrentInstance();
		//获取平台信息
		function getPlateInfo() {
			proxy.$request({
				url: "N_FINDDISTLIST",
				method: "post", //可以不传method 默认是post请求，
			}).then((res) => {
				if (res.data.code == "000") {

				} else {
				
				}
			})
		}
		return {
			
		};
	},
};
</script>
<style scoped lang="less">
.plant {
	width: 100%;
	height: 100%;
}
</style>	
  